import Loading from "@/src/common/Loading";
import { useAuth } from "@/src/provider/AuthProvider";
import { useNavigate } from "react-router-dom";

const Logout = ({ logoutCallback }) => {
  const { setToken } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutCallback();
    setToken();
    localStorage.clear();
    navigate("/", { replace: true });
  };

  setTimeout(() => {
    handleLogout();
  }, 3 * 1000);

  return (
    <div>
      <Loading label="Logging out... Please wait!" />
    </div>
  );
};

export default Logout;
